export class ListTableMaintenanceRunsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runType",
            "baseName": "runType",
            "type": "MaintenanceRunTypeFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MaintenanceRunStatusFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableMaintenanceRunsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
